var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Flex',{class:[_vm.minify ? 'tags--minified' : false]},[_vm._l((_vm.computedData),function(tag){return _c('Cta',{key:tag.term_id,staticClass:"tag",attrs:{"data":{
      title: tag.name,
      url: isNaN(tag.term_id) ? tag.slug : `/${_vm.postType === 'post' ? 'magazine' : _vm.postType}/tag/${tag.slug}`,
      size: 'label'
    }}})}),(_vm.minify && ((_vm.computedData.length > 4 && !_vm.$mq.isMobile) || (_vm.computedData.length > 2 && _vm.$mq.isMobile)))?_c('div',{staticClass:"tag tag-more"},[_vm._v(" ... ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }